<template>
  <div class="listing">
    <section class="page">
      <header class="pageHeader">
        <div class="pageHeader__Inner">
          <h1 class="pageHeader__Title">Websites</h1>

          <ul class="pageHeader__Meta">
            <li>
              <router-link class="button" :to="{ name: 'Add website' }">Add website</router-link>
            </li>
          </ul>
        </div>
      </header>

      <div class="tab">
        <div class="tab__Wrapper">
          <websites :filters="filters" :allowSubscription="false" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Websites from '@/components/settings/Websites.vue'

export default {
  name: 'WebsitesListing',
  components: {
    Websites,
  },
}
</script>
